import { Link } from 'react-router-dom';
import { ArrowRight, HandCoins, Landmark, Users } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { PageHeader } from '@/components/layout/PageHeader';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card';

interface LoanLink {
  to: string;
  title: string;
  icon: LucideIcon;
}

const LOANS: LoanLink[] = [
  {
    to: '/financials/loans/family',
    title: 'Family loan',
    icon: Users,
  },
  {
    to: '/financials/loans/sba',
    title: 'SBA loan',
    icon: Landmark,
  },
];

/**
 * Landing page for the Loans sub-section. Surfaces the two loan
 * surfaces (Family and SBA) as cards so a super admin can pick which
 * note they're working in. The same gating that protects the other
 * financials pages (super_admin + financials MFA, via the route
 * wrapper in `App.tsx`) covers this page.
 */
export function LoansPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Loans"
      />

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <HandCoins className="h-5 w-5 text-old-growth" strokeWidth={1.6} />
            Active loan ledgers
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-3 sm:grid-cols-2">
            {LOANS.map((loan) => (
              <Link
                key={loan.to}
                to={loan.to}
                className="group flex flex-col gap-2 rounded-lg border border-border bg-card/60 p-4 transition-colors hover:border-old-growth hover:bg-card"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <loan.icon
                      className="h-4 w-4 text-old-growth"
                      strokeWidth={1.6}
                    />
                    <span className="text-sm font-medium text-foreground">
                      {loan.title}
                    </span>
                  </div>
                  <ArrowRight
                    className="h-4 w-4 text-muted-foreground transition-transform group-hover:translate-x-0.5 group-hover:text-old-growth"
                    strokeWidth={1.6}
                  />
                </div>
              </Link>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
